<template>
  <div class="home">
    <div class="images">
      <loopPlayImages
        v-if="bannerImagesData != null"
        :images-data="bannerImagesData"
        :background-appe-mode="false"
        :default-classes="loopPlayImagesData.defaultClasses"
      ></loopPlayImages>
    </div>
    <div class="popular_box"></div>
    <div style="margin-top: 540px;"></div>
    <!-- <div class="KeyListView">
      <KeywordList
        :info="keyListContentData"
        @moreClick="moreClick"
        @targetChange="targetChange"
      />
    </div> -->
    <div class="movieList" v-for="(item, i) in templateData" :key="i">
      <ImageList
        :info="item"
        @moreClick="moreContentsClick"
        @movieClick="movieClick"
      />
    </div>
    <div class="advertisement" v-if="bottomBanner">
      <a :href="`${bottomBanner.link}`" target="_blank">
        <img :src="bottomBanner.image" :alt="bottomBanner.title" />
      </a>
    </div>
  </div>
</template>

<script>
import bus from "@/utils/eventBus";
import loopPlayImages from "@/components/loopPlayImages/loopPlayImages.vue";
import "../assets/css/loopPlayImages.css";
import KeywordList from "@/components/gaoyinghao/keywordList.vue";
import ImageList from "@/components/gaoyinghao/imageList.vue";
import "../assets/css/Home.css";
import $ from "jquery";

const IMAGESCONST = {
  电影: { icon: "movie_icon" },
  电视剧: { icon: "special" },
  娱乐: { icon: "recreation" },
  RMHD: { icon: "vip" },
  精品: { icon: "boutique" },
  热播: { icon: "host" },
};

export default {
  name: "special-page",
  components: {
    loopPlayImages,
    KeywordList,
    ImageList,
  },
  computed: {
    pageTitle() {
      return this.$route.query.pageTitle || "电影";
    },
    detailPage() {
      return this.$route.query.detailPage || "TVplayPage";
    },
  },
  created() {
    this.$nextTick(() => {
      // 设置footer
      bus.$emit("updateFooter", this.pageTitle);
    });
  },
  mounted: function () {
    // 设置keywords
    let keywords = this.$route.query.pageTitle;
    let keywordsMeta = document.getElementsByTagName("meta")["keywords"];
    keywordsMeta.content = `${keywords}, 瑞网娱乐`;
    var self = this;
    this.$axios({
      url: "/realNet/pageManager/findOne",
      method: "get",
      headers: {
        token: "123456789",
      },
      params: {
        title: self.pageTitle,
      },
    }).then(function (resp) {
      if (resp.data.result) {
        //轮播图区数据处理
        var dataMap = resp.data.result.dataMap;
        self.bottomBanner = dataMap.bottomBanner
          ? dataMap.bottomBanner[0]
          : null;

        if (dataMap.bannerList) {
          self.bannerImagesData = dataMap.bannerList.map((item) => {
            return {
              backgroundImage: item.image,
              imageLinkRouterName: item.link,
            };
          });
        }
        //关键字区域
        // self.keyListContentData = dataMap.menuList;
        if (dataMap.menuList != undefined && dataMap.menuList != null) {
          let keyListContentDataList = [];
          dataMap.menuList.forEach((item) => {
            keyListContentDataList = [
              ...keyListContentDataList,
              ...item.menuList,
            ];
          });
          self.keyListContentData = keyListContentDataList;
        }

        //内容区数据处理
        var tempData = new Array(dataMap.contentTemplateList.length);
        var tempDataCount = 0;
        dataMap.contentTemplateList.map((item, idx) => {
          var requestParamsData = {
            orderByField: item.searchSortOrder,
            orderByType: item.searchSortOrderType,
            pageSize: 8,
            pageNum: 0,
          };
          try {
            var requestParamsId = JSON.parse(item.searchField);
            if (requestParamsId)
              Object.assign(requestParamsData, requestParamsId);
          } catch (ignore) {
            // do nothing
          }
          var imgAttr = self.getImgAttr(item, IMAGESCONST);
          var maxImgCount = Math.floor(
            (document.body.clientWidth * 0.9) / (imgAttr.imgWidth + 20)
          );
          if (imgAttr.type == "boutique") {
            maxImgCount =
              1 +
              Math.floor(
                (document.body.clientWidth * 0.9 - 532) /
                  (imgAttr.imgWidth + 20)
              );
          }
          self
            .$axios({
              url: "/realNet/video/getVideoInfos",
              method: "get",
              headers: {
                token: "123456789",
              },
              params: requestParamsData,
            })
            .then(function (resp) {
              var contentData = resp.data.result.content;

              var contentInfoData = {
                title: item.name,
                type: imgAttr.type,
                icon: require("../assets/icon/" + imgAttr.icon + ".png"),
                searchField: item.searchField,
                list: [],
                recommendList: [],
              };
              if (contentData) {
                contentData.map((listItem, i) => {
                  var thumbImg = listItem.verticalImage;
                  if (
                    (imgAttr.type == "boutique" && i == 0) ||
                    imgAttr.type == "host"
                  ) {
                    thumbImg = listItem.horizontalImage;
                  }

                  if (i < 5) {
                    contentInfoData.list.push({
                      id: listItem.id,
                      img: thumbImg,
                      name: listItem.videoName,
                      intro: listItem.description,
                      grade: listItem.score,
                    });
                  } else {
                    contentInfoData.recommendList.push({
                      id: listItem.id,
                      name: listItem.videoName,
                    });
                  }
                });
                tempData[idx] = contentInfoData;
                if (++tempDataCount == tempData.length)
                  self.templateData = tempData;
              }
            });
        });
      }
    });
  },
  data: function () {
    return {
      bannerImagesData: null,
      loopPlayImagesData: {
        defaultClasses: {
          outerRotateStage: "loopImages",
          rotateStageClass: "loopStage",
          innerShowClass: "loopContainer",
          btnClass: "btnOuter",
          circularClass: "dots",
        },
      },
      bottomBanner: null,
      keyListContentData: null,
      templateData: null,
      key: false,
    };
  },
  methods: {
    initKeyListViewData(data, k) {
      if (k) {
        var infoData = {},
          list = [
            {
              name: "全部",
              target: "all",
              isActive: true,
            },
          ];

        infoData.title = data.name ? data.name : "";
        infoData.isRadio = true;
        data.menuList.map((item, idx) => {
          list.push({
            name: item.name ? item.name : "",
            target: item.url ? item.url : item.searchField,
          });
        });
        infoData.list = list;

        return infoData;
      } else {
        return {};
      }
    },
    getImgAttr(item, changObj) {
      var imgAttr = {
        icon: "comedy",
        type: "comedy",
        imgWidth: 192,
      };
      for (var k in changObj) {
        if (item.name.indexOf(k) > -1) {
          imgAttr.icon = changObj[k].icon;
          break;
        }
      }
      if (item.firstImageFeature) {
        imgAttr.type = "boutique";
        imgAttr.imgWidth = 192;
      } else if (item.usageImage == 1) {
        imgAttr.type = "host";
        imgAttr.imgWidth = 256;
      }
      return imgAttr;
    },
    /*关键字列表 点击 ‘更多’ 回调*/
    moreClick(type) {
      this.$router.push({ path: "/search" });
    },
    /*关键字列表 点击类型回调*/
    targetChange(info) {
      this.$router.push({
        path: "/search",
        query: {
          searchField: info[0].searchField,
        },
      });
    },
    /*图片列表 点击“更多”回调*/
    moreContentsClick(info) {
      this.$router.push({
        path: "/search",
        query: {
          searchField: info.searchField,
        },
      });
    },
    /*图片列表 点击“电影”回调*/
    movieClick(option) {
      this.$router.push({
        name: this.detailPage,
        query: {
          contentId: option.infoItem.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.advertisement {
  margin-top: 28px;
  width: 100%;
  a > img {
    width: 100%;
    height: auto;
  }
}
.TVplay #loopImages {
  position: absolute;
  top: 0;
}
</style>
